import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { MultiSelect } from 'primereact/multiselect';
import { Chip } from '@uni-of-exeter/digital.lib.react.ui.kit';

import './digital-skills-category-select.css';

// TODO: Move this component to the UI Library and make it reusable & enable multi-select once api is updated

interface DigitalSkillsCategorySelectProps {
  value: string[];
  options: {
    label: string;
    value: string;
    color: string;
  }[];
  onChange: (value: string[]) => void;
  label: string;
}

const DigitalSkillsCategorySelect: React.FC<DigitalSkillsCategorySelectProps> = ({
  value,
  options,
  onChange,
  label,
}) => {
  const customSelectedItemsLabel = () => {
    return <>Digital skills category</>;
  };

  const itemTemplate = (option: { label: string; value: string; color: string }) => {
    const chipId = `dsc_${option.value}`;
    const isSelected = value.includes(option.value);

    return (
      <div className="digitalSkillsCategorySelectOption">
        <Chip
          id={chipId}
          label={option.label}
          className="mr-2 digitalSkillsCategorySelectOptionChip"
          backgroundColor={option.color}
          role="presentation"
        />
        <Checkbox
          aria-labelledby={chipId}
          style={{
            display: 'none',
          }}
          checked={isSelected}
          onChange={() => {
            if (isSelected) {
              onChange(value.filter((v) => v !== option.value));
            } else {
              onChange([...value, option.value]);
            }
          }}
        />

        {isSelected ? (
          <i
            className="fa-solid fa-check-square"
            style={{ color: 'var(--light-text-highlight)' }}
          ></i>
        ) : (
          <i className="fa-regular fa-square"></i>
        )}
      </div>
    );
  };

  return (
    <div className="digitalSkillsCategorySelect">
      <MultiSelect
        id="skillCategoryMultiSelect"
        value={value}
        onChange={(e) => onChange(e.value)}
        options={options}
        optionLabel="label"
        placeholder="Select Categories"
        selectedItemTemplate={customSelectedItemsLabel}
        maxSelectedLabels={0}
        selectedItemsLabel={`{value.length} Digital skills category`}
        itemTemplate={itemTemplate}
        itemCheckboxIcon="pi pi-check"
        aria-label={label}
        role="search"
        pt={{
          input: {
            autocomplete: 'off',
            'aria-label': label,
            'aria-controls': 'skillCategoryMultiSelect',
          },
          list: {
            'aria-label': label,
          },
          wrapper: {
            tabIndex: 0,
            role: 'complementary',
          },
        }}
      />
    </div>
  );
};

export default DigitalSkillsCategorySelect;
